"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsCycle = exports.getCycleMap = exports.replaceTypeAsArrayWithOneOf = exports.mergeObjectProperties = exports.combineSchemas = exports.sortEntriesByKey = exports.joinSchemaTitles = exports.schemaToRef = exports.getTitle = exports.languageSafeName = exports.numToWord = exports.capitalize = void 0;
var lodash_deburr_1 = __importDefault(require("lodash.deburr"));
var lodash_trim_1 = __importDefault(require("lodash.trim"));
var traverse_1 = __importDefault(require("@json-schema-tools/traverse"));
var titleizer_1 = __importDefault(require("@json-schema-tools/titleizer"));
/**
 * Capitalize the first letter of the string.
 *
 * @param s A word to capitalize. Does not account for leading white spaces.
 *
 * @return capitalized version of the input
 */
var capitalize = function (s) { return s[0].toUpperCase() + s.slice(1); };
exports.capitalize = capitalize;
var regexes = [
    /(^\s*[^a-zA-Z_$])|([^a-zA-Z_$\d])/g,
    /^_[a-z]/g,
    /_[a-z]/g,
    /([\d$]+[a-zA-Z])/g,
    /\s+([a-zA-Z])/g,
    /\s|_/g,
];
var digitRegex = /\d/g;
var numToWord = function (s) {
    return s.replace(digitRegex, function (match) {
        switch (match) {
            case "0": return "Zero";
            case "1": return "One";
            case "2": return "Two";
            case "3": return "Three";
            case "4": return "Four";
            case "5": return "Five";
            case "6": return "Six";
            case "7": return "Seven";
            case "8": return "Eight";
            case "9": return "Nine";
            default: return match;
        }
    });
};
exports.numToWord = numToWord;
var languageSafeName = function (title) {
    return exports.capitalize(lodash_deburr_1.default(title)
        .replace(regexes[0], " ")
        .replace(regexes[1], function (match) { return match.toUpperCase(); })
        .replace(regexes[2], function (match) { return match.substr(1, match.length).toUpperCase(); })
        .replace(regexes[3], function (match) { return match.toUpperCase(); })
        .replace(regexes[4], function (match) { return lodash_trim_1.default(match.toUpperCase()); })
        .replace(regexes[5], ""));
};
exports.languageSafeName = languageSafeName;
var getTitle = function (s) {
    if (s === true) {
        return "AlwaysTrue";
    }
    if (s === false) {
        return "AlwaysFalse";
    }
    if (s.title) {
        return s.title;
    }
    throw new Error("Could not extract title from schema: " + JSON.stringify(s));
};
exports.getTitle = getTitle;
var schemaToRef = function (s) {
    var ref = exports.getTitle(s);
    return { $ref: "#/definitions/" + ref };
};
exports.schemaToRef = schemaToRef;
var joinSchemaTitles = function (s) {
    return s.map(exports.getTitle).join("_");
};
exports.joinSchemaTitles = joinSchemaTitles;
var sortEntriesByKey = function (_a, _b) {
    var key1 = _a[0];
    var key2 = _b[0];
    return key1 > key2 ? -1 : 1;
};
exports.sortEntriesByKey = sortEntriesByKey;
function combineSchemas(s) {
    var combinedDefinitions = {};
    s.forEach(function (schema) {
        if (schema === true || schema === false) {
            combinedDefinitions[exports.getTitle(schema)] = schema;
        }
        else {
            combinedDefinitions = __assign(__assign({}, combinedDefinitions), schema.definitions);
        }
    });
    var withoutDefinitions = s.map(function (ss) {
        if (ss === true || ss === false) {
            return ss;
        }
        var copy = __assign({}, ss);
        delete copy.definitions;
        return copy;
    });
    var uniquedSchemas = withoutDefinitions.reduce(function (uniqued, schema) {
        if (uniqued.find(function (us) {
            if (us === true || us === false || schema === true || schema === false) {
                return us === schema;
            }
            return us.title === schema.title;
        }) === undefined) {
            return __spreadArray(__spreadArray([], uniqued), [
                schema,
            ]);
        }
        return uniqued;
    }, []);
    uniquedSchemas.forEach(function (us) {
        return combinedDefinitions[exports.getTitle(us)] = us;
    });
    return {
        title: "AnyOf_" + exports.joinSchemaTitles(s),
        description: "Generated! Represents an alias to any of the provided schemas",
        anyOf: uniquedSchemas.map(exports.schemaToRef),
        definitions: combinedDefinitions,
    };
}
exports.combineSchemas = combineSchemas;
function mergeObjectProperties(schemas) {
    var merged = schemas
        .filter(function (s) {
        if (s === true || s === false) {
            return false;
        }
        else {
            return !!s.properties;
        }
    })
        .map(function (_a) {
        var properties = _a.properties;
        return properties;
    })
        .reduce(function (all, schema) { return (__assign(__assign({}, all), schema)); }, {});
    return merged;
}
exports.mergeObjectProperties = mergeObjectProperties;
function replaceTypeAsArrayWithOneOf(schema) {
    return traverse_1.default(schema, function (subS) {
        var subSchema = titleizer_1.default(subS);
        if (subS !== true && subS !== false && subS.type instanceof Array) {
            console.warn([
                "One of the provided schemas is using an array for the field type. This is not",
                "advisable, as oneOf is the equivalent. In (far) future releases, type as an array",
                "support will be deprecated."
            ]);
            if (subS.length === 1) {
                subS.type = subS.type[0];
            }
            else {
                var newSubSchemas = subS.type.map(function (subType) { return (__assign(__assign({}, subS), { title: subSchema.title + "As" + exports.capitalize(subType), type: subType })); });
                subS.oneOf = newSubSchemas;
                delete subS.type;
            }
        }
        return subS;
    }, { mutable: true });
}
exports.replaceTypeAsArrayWithOneOf = replaceTypeAsArrayWithOneOf;
function getCycleMap(ss) {
    return ss.reduce(function (m, s) {
        traverse_1.default(s, function (subs, isCycle) {
            if (subs === true || subs === false) {
                return subs;
            }
            if (isCycle) {
                m[exports.schemaToRef(subs).$ref] = true;
            }
            return subs;
        });
        return m;
    }, {});
}
exports.getCycleMap = getCycleMap;
var checkCycle = function (cycleMap) { return function (subs) {
    if (subs !== true && subs !== false && subs.$ref && cycleMap[subs.$ref]) {
        subs.isCycle = true;
    }
    return subs;
}; };
function setIsCycle(s, cycleMap) {
    if (s === true || s === false) {
        return s;
    }
    traverse_1.default(s, checkCycle(cycleMap), { mutable: true });
    if (s.definitions !== undefined) {
        var defs_1 = s.definitions;
        Object.keys(defs_1).forEach(function (subsKey) {
            if (cycleMap["#/definitions/" + subsKey]) {
                defs_1[subsKey].isCycle = true;
            }
        });
        var definitionSchemas = Object.values(defs_1);
        definitionSchemas.forEach(function (ds) {
            traverse_1.default(ds, checkCycle(cycleMap), { mutable: true });
        });
    }
    if (cycleMap["#/definitions/" + s.title]) {
        s.isCycle = true;
    }
    return s;
}
exports.setIsCycle = setIsCycle;
